  $(document).ready(function() {
  	$('.collapse').on('show.bs.collapse', function() {
  		$(this).closest('.panel').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up');
  	});
  	$('.collapse').on('hide.bs.collapse', function() {
  		$(this).closest('.panel').find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down');
  	});
  })
  $( ".click-job-lightbox" ).click(function() {
	$('.modal-jobs-form').addClass('active');

	var job_data = $(this).attr('data-job-info');
	console.log(job_data);
	$('[name*="db[5158]"]').val(job_data);
  });
  $( "body" ).on( "click", ".black-shutter, .click_close", function() {
	$('.modal-jobs-form').removeClass('active');
  });
